export { default as Hero } from './Hero';
export { default as OurMission } from './OurMission';
export { default as GuidedByScience } from './GuidedByScience';
export { default as OurTale } from './OurTale';
export { default as Story } from './Story';
export { default as Today } from './Today';
export { default as Quotes } from './Quotes';
